import React from "react";

function CtaSection({
  title,
  buttonText,
  subText,
  formLink,
  subComment,
  backgroundColor = "var(--white)",
}) {
  return (
    <section
      style={{
        background: backgroundColor,
        padding: "40px 0",
        textAlign: "center",
      }}
    >
      {title && (
        <h2
          style={{
            marginBottom: "20px",
            fontSize: "38px",
            fontWeight: 800,
            fontFamily: "'Bebas Neue', sans-serif",
            color: "var(--white)",
          }}
        >
          {title}
        </h2>
      )}
      <div className="asc-container">
        <a href={formLink} className="asc-cta-button">
          {buttonText}
        </a>

        <p
          style={{
            marginTop: "16px",
            fontSize: "14px",
            color: "var(--gray)",
            textTransform: "uppercase",
            letterSpacing: "1px",
            fontWeight: 600,
          }}
        >
          {subText}
        </p>
        <p
          style={{
            marginTop: "8px",
            fontSize: "13px",
            color: "var(--gray)",
            fontStyle: "italic",
          }}
        >
          {subComment}
        </p>
      </div>
    </section>
  );
}

export default CtaSection;
